import { Card, CardBody } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import stopIcon from 'src/assets/icons/stop.svg';

import { I18NextNS } from 'src/models/Language.model';

export default function CameraReconnectionFailedCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'cameraConnectionIssue.reconnectionFailedCard',
  });

  return (
    <Card
      bg="danger-100"
      className="border-0 overflow-hidden position-relative"
    >
      {/* Cannot use border because inner radius will be rounded */}
      <div
        className="bg-danger position-absolute top-0 start-0 h-100"
        style={{ width: '0.25rem' }}
      />
      <CardBody>
        <div className="d-flex align-items-center gap-2">
          <img src={stopIcon} alt={t('imgAlt')} className="flex-shrink-0" />
          <h6 className="mb-0">{t('title')}</h6>
        </div>
      </CardBody>
    </Card>
  );
}
